import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { updateToken } from "../../reducers/authReducer";
import useRemoteParams from "../../hooks/useRemoteParams";
import useTemplateInterpreter from "../../hooks/useTemplateInterpreter";
import { OnboardingType } from "../../types";
import { loadFavicon } from "../../utils";

const RemoteStep = () => {
  const {
    values: { onboardingType, uuid, token },
  } = useRemoteParams();

  const dispatch = useAppDispatch();

  const state = useAppSelector((state) => state);

  const { favicon, remoteSteps } = state.activeTemplate;

  const path = window.location.pathname;
  const step = remoteSteps?.find((step) => step.link === path)?.step.component;

  const { loadTemplate } = useTemplateInterpreter({
    dispatch,
    onboardingType: onboardingType as OnboardingType,
    state,
    draftUUID: uuid,
  });

  useEffect(() => {
    loadTemplate();
  }, [uuid]);

  useEffect(() => {
    if (favicon) {
      loadFavicon(favicon);
    }
  }, [favicon]);

  useEffect(() => {
    if (token) dispatch(updateToken(token));
  }, [token]);

  return step ? step(dispatch, state) : <></>;
};

export default RemoteStep;
